import img1 from "./team26/Ananya.png";
import img2 from "./team26/priyanshu2.png";
import img3 from "./team26/krithika.png";
import img4 from "./team26/Renu.png";
import img5 from "./team26/Revanth.png";
import img6 from "./team26/Angelica.png";
import img7 from "./team26/jeswanth1.png";
import img8 from "./team26/Prathik.png";
import img9 from "./team26/Bindhu1.png";
import img10 from "./team26/Akhil.png";
import img11 from "./team26/Alekh.png";
import img12 from "./team26/Siddant.png";
import img13 from "./team26/Ajay.png";

const team26_Data = [
    {id: 1,name: "Ananya",role: "Licensee",image: img1,linkedin: "https://www.linkedin.com/in/kasukurthi-ananya-740639344/"},
    {id: 2,name: "Priyanshu",role: "Co-Licensee & Content Head",image: img2,linkedin: "https://www.linkedin.com/in/priyanshu-kumar-7a5801296/"},
    {id: 3,name: "Kritika",role: "Content Core",image: img3,linkedin: "https://www.linkedin.com/in/kritikashree/"},
    {id: 4,name: "Renu",role: "Content Core",image: img4,linkedin: "https://www.linkedin.com/in/madduluri-renu-sanjana-0a8869306/"},
    {id: 5,name: "Revanth",role: "Web Ops Head",image: img5,linkedin: "https://www.linkedin.com/in/revanth-reddy-tarimala-5621a7296/"},
    {id: 6,name: "Angelica",role: "Speakers Head",image: img6,linkedin: "https://www.linkedin.com/in/angelica-das-7aabb927a/"},
    {id: 7,name: "Jeshwanth",role: "Marketing Head",image: img7,linkedin: "https://www.linkedin.com/in/jeshwanth-sreeram-308b14282/"},
    {id: 8,name: "Pratik",role: "Marketing Core",image: img8,linkedin: "https://www.linkedin.com/in/pratikbhagat20/"},
    {id: 9,name: "Bindhu",role: "PR & Media Head",image: img9,linkedin: "https://www.linkedin.com/in/bindhu-pawar/"},
    {id: 10,name: "Akhil",role: "PR & Media Core",image: img10,linkedin: "https://www.linkedin.com/in/akhilravipati01/"},
    {id: 11,name: "Alekh",role: "Creatives Head",image: img11,linkedin: "https://www.linkedin.com/in/alekh-sethi-b1ba03285/"},
    {id: 12,name: "Siddhant",role: "Events Head",image: img12,linkedin: "https://www.linkedin.com/in/siddhant-kumawat/"},
    {id: 13,name: "Ajay",role: "Events Core",image: img13,linkedin: ""},
];

export default team26_Data;
